<template>
  <div class="system-management">
    <!-- 如果有子路由，显示子路由内容 -->
    <router-view v-if="$route.path !== '/systemManagement'"></router-view>
    
    <!-- 如果没有子路由，显示系统管理主页 -->
    <div v-else>
      <!-- 菜单卡片区域 -->
      <div class="menu-cards">
        <div class="card-row">
          <!-- 用户管理 -->
          <div class="menu-card" @click="navigateTo('/systemManagement/userManagement')">
            <div class="card-icon">
              <i class="el-icon-user"></i>
            </div>
            <div class="card-content">
              <h3>用户管理</h3>
              <p>管理系统用户信息，包括用户增删改查、角色分配等功能</p>
            </div>
          </div>

          <!-- 角色管理 -->
          <div class="menu-card" @click="navigateTo('/systemManagement/roleManagement')">
            <div class="card-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <div class="card-content">
              <h3>角色管理</h3>
              <p>管理系统角色，包括角色创建、权限分配、菜单配置等功能</p>
            </div>
          </div>

          <!-- 菜单管理 -->
          <div class="menu-card" @click="navigateTo('/systemManagement/menuManagement')">
            <div class="card-icon">
              <i class="el-icon-menu"></i>
            </div>
            <div class="card-content">
              <h3>菜单管理</h3>
              <p>管理系统菜单结构，包括菜单创建、排序、权限配置等功能</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SystemManagement",
  methods: {
    navigateTo(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="less" scoped>
.system-management {
  padding: 20px;
  background: #f5f7fa;
  .menu-cards {
    .card-row {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 24px;
      max-width: 1200px;
    }

    .menu-card {
      background: white;
      border-radius: 8px;
      padding: 24px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      transition: all 0.3s ease;
      border: 1px solid #e4e7ed;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        border-color: #409eff;
      }

      .card-icon {
        width: 60px;
        height: 60px;
        background: linear-gradient(135deg, #409eff, #66b1ff);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;

        i {
          font-size: 24px;
          color: white;
        }
      }

      .card-content {
        h3 {
          margin: 0 0 8px 0;
          font-size: 18px;
          font-weight: 600;
          color: #303133;
        }

        p {
          margin: 0;
          font-size: 14px;
          color: #606266;
          line-height: 1.5;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .system-management {
    padding: 10px;
    
    .menu-cards .card-row {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }
}
</style>
